import React from 'react';
import Footer from '../FooterComponent/Footer';
import { connect } from 'react-redux';

class ErrorHomePage extends React.Component{
    render(){
        const { footerData } = this.props;
        return(
            <>
                <div className="error-msg">Sorry, this page is not available!</div>
                <Footer leftColData={footerData.footer !== undefined &&
                footerData.footer['footer-left-menu']} showSocialIcons />
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    footerData: state.HeaderFooterData.items,
});

export default connect(mapStateToProps)(ErrorHomePage);